<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Historial</span>
                    </v-card-title>
                    <v-card-text>
                        <DataTable :url="url"
                                   class="reporteAut"
                                   :columns="head"
                                   :params="displayInputs"
                                   :order="[]"
                                   dom="<'row'<'col-sm-6'l><'col-sm-6 align-content:left'f>><'row'<'col-sm-12'tr >><'row'<'col-sm-6 text-center'p><'col-sm-6'i>>"
                                   @apiDT="apiDT = $event">
                        </DataTable>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable,
            Menu
        },
        data() {
            return {
                showcargando: true,
                apiDT: null,
                url: 'Sistemas/Historial',
                displayInputs: {
                    shclave: 0,
                },
                head: [
                    { name: "shsp", data: "shsp", title: "Reporte", },
                    { name: "shfechae", data: "shfechae", title: "Fecha de ejecución" },
                    { name: "sherror", data: "sherror", title: "Error", formatter: [this, "Estado"], },
                    { name: "shdescripcion", data: "shdescripcion", title: "Descripción del error", },
                ],
                datos: {},
                ver: false,
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        methods: {
            Estado(datos) {
                if (datos.sherror == null) {
                    return `<span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus blue-grey theme--dark"></i></span>`;
                }
                else if (datos.sherror == false) {
                    return `<span class="v-btn__content" title="No"><i aria-hidden="true" class="v-icon notranslate mdi mdi-check success theme--dark"></i></span>`;
                }
                else if (datos.sherror == true) {
                    return `<span class="v-btn__content" title="Si"><i aria-hidden="true" class="v-icon notranslate mdi mdi-close error theme--dark"></i></span>`;
                }
            },
        },
        async mounted() {
            this.showcargando = false;
            this.datos = await MetodosGenerales.obtenerSessionReporte("Tarea");
            this.displayInputs = {
                shclave: this.datos.shclave
            };
            this.ver = true;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '60').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>